// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import {
//   addManualQuestion,
//   setNewQuestionForm,
//   setState,
//   fetchThemes,
//   fetchQuizTypes,
//   fetchSubjects,
//   fetchSubjectBasedClassesData,
// } from "./redux/schoolQuizSlice";
// import {
//   fetchClassesThunk,
//   fetchSubjectsByClassThunk,
// } from "../../components/chapter/redux/chapterThunk";
// import API_BASE_URL, { SCHOOL_QUIZ_API_BASE_URL } from "../config";
// import { getAgeGroups } from "../../School-Quiz-Mgt-admin/redux/thunk";

// export default function AddManualQuestion() {
//   const dispatch = useDispatch();

//   // Use schoolQuiz slice (keeps consistency with other components)
//   const {
//     newQuestionForm = {},
//     themes = [],
//     subThemes,
//     ageGrps,
//     age_group_id,
//     selectedSubThemes,
//     subQuizType,
//     quizType,
//     loading,
//     quizTypesList,
//     subjectsList,
//     subjectBasedClasses,
//   } = useSelector((state) => state.schoolQuiz || {});

//   // chapter slice for classes/subjects
//   const { classes = [], subjects = [] } = useSelector(
//     (state) => state.chapter || {}
//   );

//   // Local state
//   const [groups, setGroups] = useState([]);
//   const [error, setError] = useState("");

//   // useEffect(() => {
//   //   if (quizType === "thematic") {
//   //     dispatch(getAgeGroups());
//   //   }
//   // }, [quizType]);
//   // Destructure form fields (these keys are kept in redux form)
//   const {
//     question = "",
//     option_a = "",
//     option_b = "",
//     option_c = "",
//     option_d = "",
//     correct_option = "",
//     difficulty_level = "",
//     class_id = "",
//     subject_id = "",
//     theme_id = "",
//     group_id = "",
//   } = newQuestionForm;

//   // safe user id parsing
//   const userStr = localStorage.getItem("user");
//   const userObj = userStr ? JSON.parse(userStr) : {};
//   const userId = userObj?.id ?? userObj?.user_id ?? "";

//   // Fetch classes, themes and groups on mount
//   useEffect(() => {
//     dispatch(fetchClassesThunk());
//     dispatch(fetchThemes());
//     dispatch(fetchQuizTypes());
//     fetchGroups();
//     dispatch(fetchSubjects());
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [dispatch]);
//   useEffect(() => {
//     if (newQuestionForm?.subject_id) {
//       const subject_id = newQuestionForm?.subject_id;
//       dispatch(
//         fetchSubjectBasedClassesData({
//           subject_id,
//         })
//       );
//     }
//   }, [dispatch, newQuestionForm?.subject_id]);

//   // Fetch groups (same pattern used in other components)
//   const fetchGroups = async () => {
//     setError("");
//     try {
//       const res = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/groups`);
//       setGroups(Array.isArray(res.data) ? res.data : res.data?.data || []);
//     } catch (err) {
//       setError("Failed to fetch groups");
//       console.error("fetchGroups error:", err);
//     }
//   };

//   // When a class is selected, fetch subjects for that class
//   useEffect(() => {
//     if (class_id) {
//       // ensure numeric id if your thunk expects it
//       dispatch(fetchSubjectsByClassThunk(Number(class_id)));
//     }
//   }, [class_id, dispatch]);

//   // Generic form field update -> stores to redux newQuestionForm
//   const handleChange = (key, value) => {
//     dispatch(setNewQuestionForm({ key, value }));
//   };

//   const handleFieldChange = (e) => {
//     //debugger
//     const { name, value } = e.target;
//     // correct payload shape expected by reducer:
//     dispatch(setNewQuestionForm({ key: name, value }));
//   };

//   // Validation: require common fields + conditional fields based on quizType
//   const isCommonValid =
//     question.trim() &&
//     option_a.trim() &&
//     option_b.trim() &&
//     option_c.trim() &&
//     option_d.trim() &&
//     correct_option.trim() &&
//     difficulty_level;

//   const isFormValid =
//     quizType === "thematic"
//       ? isCommonValid && theme_id && group_id
//       : isCommonValid && class_id && subject_id;

//   const handleThemeChange = (e) => {
//     //debugger;
//     const value = e.target.value;
//     // update redux form properly
//     dispatch(setNewQuestionForm({ key: "theme_id", value }));
//     dispatch(
//       setState({
//         key: "selectedSubThemes",
//         value: [],
//       })
//     );
//     const filtered =
//       themes.find((e) => e.theme_id === Number(value))?.sub_theme || [];
//     dispatch(
//       setState({
//         key: "subThemes",
//         value: filtered,
//       })
//     );
//     // console.log("themens", themes);
//     // handleChange("theme_id", value);
//   };

//   // Submit handler builds payload depending on quizType
//   const handleSubmit = async () => {
//     if (!isFormValid) {
//       alert("Please fill required fields.");
//       return;
//     }

//     try {
//       const payloadBase = {
//         created_by: userId || null,
//         question,
//         correct_option,
//         option_A: option_a,
//         option_B: option_b,
//         option_C: option_c,
//         option_D: option_d,
//         level: difficulty_level,
//       };

//       const payload =
//         quizType === "thematic"
//           ? {
//               ...payloadBase,
//               // theme_id: theme_id ? Number(theme_id) : undefined,
//               theme_id: newQuestionForm.theme_id
//                 ? selectedSubThemes?.length
//                   ? selectedSubThemes
//                   : [newQuestionForm.theme_id]
//                 : [],
//               group_id: group_id ? Number(group_id) : undefined,
//               quiz_type: "thematic",
//               // age_group_id,
//             }
//           : {
//               ...payloadBase,
//               class_id: class_id ? Number(class_id) : undefined,
//               subject_id: subject_id ? Number(subject_id) : undefined,
//               quiz_type: quizType,
//               //  === "practice" ? "practice" : "live",
//             };

//       // Optional: remove undefined keys
//       Object.keys(payload).forEach(
//         (k) => payload[k] == null && delete payload[k]
//       );

//       console.log(payload);

//       // dispatch addManualQuestion (your thunk will get the payload)
//       const res = await dispatch(addManualQuestion(payload)).unwrap();

//       alert(
//         res && typeof res === "object"
//           ? res.message || "Question added successfully."
//           : String(res) || "Question added successfully."
//       );

//       // Reset form fields in Redux
//       dispatch(
//         setNewQuestionForm({
//           key: "question",
//           value: "",
//         })
//       );
//       dispatch(setNewQuestionForm({ key: "option_a", value: "" }));
//       dispatch(setNewQuestionForm({ key: "option_b", value: "" }));
//       dispatch(setNewQuestionForm({ key: "option_c", value: "" }));
//       dispatch(setNewQuestionForm({ key: "option_d", value: "" }));
//       dispatch(setNewQuestionForm({ key: "correct_option", value: "" }));
//       dispatch(setNewQuestionForm({ key: "difficulty_level", value: "" }));
//       dispatch(setNewQuestionForm({ key: "class_id", value: "" }));
//       dispatch(setNewQuestionForm({ key: "subject_id", value: "" }));
//       dispatch(setNewQuestionForm({ key: "theme_id", value: "" }));
//       dispatch(setNewQuestionForm({ key: "group_id", value: "" }));
//     } catch (error) {
//       console.error("Error adding manual question:", error);
//       const errRes = error?.response?.data || error;
//       alert(
//         errRes && typeof errRes === "object"
//           ? errRes.message || "Failed to add question."
//           : String(errRes) || "Unknown error"
//       );
//     }
//   };

//   return (
//     <div className="container-fluid w-100 mx-auto py-2 font-inter">
//       <div className="row mx-auto w-100">
//         <div className="col-md-12 w-100">
//           <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
//             Manual Entry – School Quiz Questions
//           </h3>

//           <div className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4">
//             {/* Quiz Type select */}
//             <div className="row mb-3">
//               <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                 Quiz Type
//               </label>
//               <div className="col-sm-8 d-flex align-items-center gap-3">
//                 {[
//                   { label: "Live", value: 1 },
//                   { label: "Practice", value: 0 },
//                 ].map((option) => (
//                   <label
//                     key={option.value}
//                     className="form-check-label d-flex align-items-center gap-2"
//                   >
//                     <input
//                       type="radio"
//                       className="form-check-input"
//                       name="quizType"
//                       value={option.value}
//                       checked={quizType === option.value} // loose equality to handle number/string
//                       onChange={(e) => {
//                         dispatch(
//                           setState({
//                             key: "quizType",
//                             value: Number(e.target.value),
//                           })
//                         );
//                         dispatch(
//                           setNewQuestionForm({ key: "theme_id", value: "" })
//                         );
//                       }}
//                       disabled={loading}
//                     />
//                     {option.label}
//                   </label>
//                 ))}
//               </div>
//               {quizType !== "" && (
//                 <>
//                   {quizType && (
//                     <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                       Sub Quiz Type
//                     </label>
//                   )}
//                   <div className="col-sm-8 d-flex align-items-center gap-3 flex-wrap">
//                     {quizTypesList?.data
//                       ?.filter((e) => e.is_live === quizType)
//                       .map((quiz) => (
//                         <label
//                           key={quiz.id}
//                           className="form-check-label d-flex align-items-center gap-2"
//                         >
//                           <input
//                             type="radio"
//                             className="form-check-input"
//                             name="subQuizType"
//                             value={quiz.id}
//                             checked={subQuizType === quiz.id} // == handles string vs number
//                             onChange={(e) => {
//                               dispatch(
//                                 setState({
//                                   key: "subQuizType",
//                                   value: Number(e.target.value),
//                                 })
//                               );
//                               dispatch(
//                                 setNewQuestionForm({
//                                   key: "theme_id",
//                                   value: "",
//                                 })
//                               );
//                             }}
//                             disabled={loading}
//                           />
//                           {quiz.type.charAt(0).toUpperCase() +
//                             quiz.type.slice(1)}
//                         </label>
//                       ))}
//                   </div>
//                 </>
//               )}
//             </div>
//             {(subQuizType === 1 || subQuizType === 2) && (
//               <div>
//                 <div className="row mb-3">
//                   <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                     Select Subject
//                   </label>
//                   <div className="col-sm-8">
//                     <select
//                       className="form-control"
//                       name="subject_id"
//                       value={newQuestionForm?.subject_id || ""}
//                       onChange={handleFieldChange}
//                       // disabled={loading || !newQuestionForm?.class_id}
//                     >
//                       <option value="">-- Select Subject --</option>
//                       {(subjectsList?.data || []).map((s) => (
//                         <option key={s.subject_id} value={s.subject_id}>
//                           {s.subject_name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//                 <div className="row mb-3">
//                   <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                     Select Class
//                   </label>
//                   <div className="col-sm-8">
//                     <select
//                       className="form-control"
//                       name="class_id"
//                       value={newQuestionForm?.class_id || ""}
//                       onChange={(e) => {
//                         handleFieldChange(e);
//                       }}
//                       disabled={loading || !newQuestionForm?.subject_id}
//                     >
//                       <option value="">-- Select --</option>
//                       {(subjectBasedClasses?.data || []).map((s) => (
//                         <option key={s.subject_id} value={s.class_id}>
//                           {s.class_name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {(subQuizType === 3 || subQuizType === 4) && (
//               <div>
//                 {/* Theme Dropdown */}
//                 <div className="row mb-3">
//                   <label className="col-sm-4 col-form-label text-gray-700">
//                     Theme
//                   </label>

//                   <div className="col-sm-8">
//                     <select
//                       className="form-control"
//                       name="theme_id"
//                       value={newQuestionForm?.theme_id || ""}
//                       onChange={handleThemeChange}
//                       disabled={loading}
//                     >
//                       <option value="">-- Select Theme --</option>
//                       {themes.map((theme) => (
//                         <option key={theme.theme_id} value={theme.theme_id}>
//                           {theme.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//                 {newQuestionForm.theme_id && subThemes?.length > 0 && (
//                   <label>
//                     <strong>Sub Themes</strong>
//                   </label>
//                 )}
//                 <br />
//                 {newQuestionForm.theme_id &&
//                   subThemes?.length > 0 &&
//                   subThemes.map((e) => {
//                     const selected = selectedSubThemes || []; // fallback in case it's undefined

//                     return (
//                       <label
//                         key={e.theme_id}
//                         style={{
//                           display: "inline-flex",
//                           alignItems: "center",
//                           marginRight: "16px", // space between labels
//                           // marginRight: "16px", // space between labels
//                           marginBottom: "8px", // small vertical gap
//                         }}
//                       >
//                         <input
//                           type="checkbox"
//                           style={{ marginRight: "20%" }}
//                           value={e.theme_id}
//                           checked={selected.includes(e.theme_id)}
//                           onChange={(event) => {
//                             const isChecked = event.target.checked;
//                             let updatedList = [];

//                             if (isChecked) {
//                               updatedList = [...selected, e.theme_id];
//                             } else {
//                               updatedList = selected.filter(
//                                 (id) => id !== e.theme_id
//                               );
//                             }

//                             dispatch(
//                               setState({
//                                 key: "selectedSubThemes",
//                                 value: updatedList,
//                               })
//                             );
//                           }}
//                           className="mr-2"
//                         />
//                         <span className="text-gray-700">{e.name}</span>
//                       </label>
//                     );
//                   })}

//                 <div className="row mb-3">
//                   <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                     Groups
//                   </label>
//                   <div className="col-sm-8">
//                     <div className="col-sm-8">
//                       <select
//                         className="form-control"
//                         name="group_id"
//                         value={newQuestionForm?.group_id || ""}
//                         onChange={handleFieldChange}
//                         disabled={loading}
//                       >
//                         <option value="">-- Select Group --</option>
//                         {groups?.data?.map((g) => (
//                           <option key={g.group_id} value={g.group_id}>
//                             {g.group_name}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Conditional fields */}
//             {quizType !== "thematic" ? (
//               <>
//                 {/* Class */}
//                 <div className="row mb-3">
//                   <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                     Class
//                   </label>
//                   <div className="col-sm-8">
//                     <select
//                       className="form-control"
//                       value={class_id || ""}
//                       onChange={(e) => handleChange("class_id", e.target.value)}
//                     >
//                       <option value="">-- Select Class --</option>
//                       {classes.map((c) => {
//                         const id = c.class_id ?? c.id;
//                         const label =
//                           c.class_name ?? c.name ?? c.title ?? `Class ${id}`;
//                         return (
//                           <option key={id} value={id}>
//                             {label}
//                           </option>
//                         );
//                       })}
//                     </select>
//                   </div>
//                 </div>

//                 {/* Subject */}
//                 <div className="row mb-3">
//                   <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                     Subject
//                   </label>
//                   <div className="col-sm-8">
//                     <select
//                       className="form-control"
//                       value={subject_id || ""}
//                       onChange={(e) =>
//                         handleChange("subject_id", e.target.value)
//                       }
//                       disabled={!class_id}
//                     >
//                       <option value="">-- Select Subject --</option>
//                       {subjects.map((s) => {
//                         const id = s.subject_id ?? s.id;
//                         const label =
//                           s.subject_name ??
//                           s.name ??
//                           s.title ??
//                           `Subject ${id}`;
//                         return (
//                           <option key={id} value={id}>
//                             {label}
//                           </option>
//                         );
//                       })}
//                     </select>
//                   </div>
//                 </div>
//                 {/* <div className="row mb-3">
//                   <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                     Difficulty
//                   </label>
//                   <div className="col-sm-8">
//                     <select
//                       className="form-control"
//                       value={difficulty_level}
//                       onChange={(e) =>
//                         handleChange("difficulty_level", e.target.value)
//                       }
//                     >
//                       <option value="">-- Select --</option>
//                       <option value="basic">Basic</option>
//                       <option value="advanced">Advanced</option>
//                       <option value="ultra">Ultra</option>
//                       <option value="docmaster">Docmaster</option>
//                     </select>
//                   </div>
//                 </div> */}
//               </>
//             ) : (
//               <>
//                 {/* Theme */}
//                 <div className="row mb-3">
//                   <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                     Theme
//                   </label>
//                   <div className="col-sm-8">
//                     <select
//                       className="form-control"
//                       value={newQuestionForm.theme_id || ""}
//                       onChange={handleThemeChange}
//                       // onChange={(e) => handleChange("theme_id", e.target.value)}
//                     >
//                       <option value="">-- Select Theme --</option>
//                       {themes.map((t) => {
//                         const id = t.theme_id ?? t.id;
//                         const label = t.name ?? t.title ?? `Theme ${id}`;
//                         return (
//                           <option key={id} value={id}>
//                             {label}
//                           </option>
//                         );
//                       })}
//                     </select>
//                   </div>
//                 </div>
//                 {theme_id && subThemes?.length > 0 && (
//                   <label>
//                     <strong>Sub Themes</strong>
//                   </label>
//                 )}
//                 <br />
//                 {newQuestionForm.theme_id &&
//                   subThemes?.length > 0 &&
//                   subThemes.map((e) => {
//                     const selected = selectedSubThemes || []; // fallback in case it's undefined

//                     return (
//                       <label
//                         key={e.theme_id}
//                         style={{
//                           display: "inline-flex",
//                           alignItems: "center",
//                           marginRight: "16px", // space between labels
//                           // marginRight: "16px", // space between labels
//                           marginBottom: "8px", // small vertical gap
//                         }}
//                       >
//                         <input
//                           type="checkbox"
//                           style={{ marginRight: "20%" }}
//                           value={e.theme_id}
//                           checked={selected.includes(e.theme_id)}
//                           onChange={(event) => {
//                             const isChecked = event.target.checked;
//                             let updatedList = [];

//                             if (isChecked) {
//                               updatedList = [...selected, e.theme_id];
//                             } else {
//                               updatedList = selected.filter(
//                                 (id) => id !== e.theme_id
//                               );
//                             }

//                             dispatch(
//                               setState({
//                                 key: "selectedSubThemes",
//                                 value: updatedList,
//                               })
//                             );
//                           }}
//                           className="mr-2"
//                         />
//                         <span className="text-gray-700">{e.name}</span>
//                       </label>
//                     );
//                   })}
//                 {false && (
//                   <div className="row mb-3">
//                     <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                       Age Groups
//                     </label>
//                     {/* {JSON.stringify(ageGrps)} */}
//                     <div className="col-sm-8">
//                       <div className="col-sm-8">
//                         <select
//                           className="form-control"
//                           name="age_group_id"
//                           value={age_group_id || ""}
//                           onChange={(e) =>
//                             dispatch(
//                               setState({
//                                 key: "age_group_id",
//                                 value: e.target.value,
//                               })
//                             )
//                           }
//                           // disabled={loading}
//                         >
//                           <option value="">-- Select Group --</option>
//                           {ageGrps.map((g) => (
//                             <option key={g.id} value={g.id}>
//                               {g.range_from}- {g.range_to}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>
//                   </div>
//                 )}

//                 {/* Group */}
//                 <div className="row mb-3">
//                   <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                     Group
//                   </label>
//                   <div className="col-sm-8">
//                     <select
//                       className="form-control"
//                       value={group_id || ""}
//                       onChange={(e) => handleChange("group_id", e.target.value)}
//                     >
//                       <option value="">-- Select Group --</option>
//                       {groups.map((g) => {
//                         const id = g.group_id ?? g.id;
//                         const label =
//                           g.group_name ?? g.name ?? g.title ?? `Group ${id}`;
//                         return (
//                           <option key={id} value={id}>
//                             {label}
//                           </option>
//                         );
//                       })}
//                     </select>
//                     {error && (
//                       <small className="text-danger d-block">{error}</small>
//                     )}
//                   </div>
//                 </div>
//               </>
//             )}

//             {/* Question input */}
//             <div className="row mb-3">
//               <label className="col-sm-4 col-form-label font-medium text-gray-700">
//                 Question
//               </label>
//               <div className="col-sm-8">
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={question}
//                   onChange={(e) => handleChange("question", e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* Options & difficulty */}
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label className="form-label text-gray-700 font-medium">
//                   Option A
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={option_a}
//                   onChange={(e) => handleChange("option_a", e.target.value)}
//                 />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label text-gray-700 font-medium">
//                   Option B
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={option_b}
//                   onChange={(e) => handleChange("option_b", e.target.value)}
//                 />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label text-gray-700 font-medium">
//                   Option C
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={option_c}
//                   onChange={(e) => handleChange("option_c", e.target.value)}
//                 />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label text-gray-700 font-medium">
//                   Option D
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={option_d}
//                   onChange={(e) => handleChange("option_d", e.target.value)}
//                 />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label text-gray-700 font-medium">
//                   Correct Option
//                 </label>
//                 <select
//                   className="form-control"
//                   value={correct_option}
//                   onChange={(e) =>
//                     handleChange("correct_option", e.target.value)
//                   }
//                 >
//                   <option value="">-- Select ---</option>
//                   <option value="A">A</option>
//                   <option value="B">B</option>
//                   <option value="C">C</option>
//                   <option value="D">D</option>
//                 </select>
//                 {/* <input
//                   type="text"
//                   className="form-control"
//                   value={correct_option}
//                   onChange={(e) =>
//                     handleChange("correct_option", e.target.value)
//                   }
//                 /> */}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label text-gray-700 font-medium">
//                   Difficulty Level
//                 </label>
//                 <select
//                   className="form-control"
//                   value={difficulty_level}
//                   onChange={(e) =>
//                     handleChange("difficulty_level", e.target.value)
//                   }
//                 >
//                   <option value="">-- Select Level --</option>
//                   <option value="basic">Basic Level</option>
//                   <option value="advanced">Advanced Level</option>
//                   <option value="ultra">Ultra Level</option>
//                   <option value="docmaster">Docmaster</option>
//                 </select>
//               </div>
//             </div>

//             <div className="text-center mt-4">
//               <button
//                 className="btn btn-primary px-4 py-2 rounded"
//                 disabled={!isFormValid}
//                 onClick={handleSubmit}
//               >
//                 Submit
//               </button>
//             </div>
//           </div>

//           <hr className="my-8 border-gray-300" />
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  addManualQuestion,
  setNewQuestionForm,
  setState,
  fetchThemes,
  fetchQuizTypes,
  fetchSubjects,
  fetchSubjectBasedClassesData,
} from "./redux/schoolQuizSlice";
import {
  fetchClassesThunk,
  fetchSubjectsByClassThunk,
} from "../../components/chapter/redux/chapterThunk";
import API_BASE_URL, { SCHOOL_QUIZ_API_BASE_URL } from "../config";
import { getAgeGroups } from "../../School-Quiz-Mgt-admin/redux/thunk";

export default function AddManualQuestion() {
  const dispatch = useDispatch();

  // Use schoolQuiz slice (keeps consistency with other components)
  const {
    newQuestionForm = {},
    themes = [],
    subThemes,
    ageGrps,
    age_group_id,
    selectedSubThemes,
    subQuizType,
    quizType = "",
    loading,
    quizTypesList,
    subjectsList,
    subjectBasedClasses,
  } = useSelector((state) => state.schoolQuiz || {});

  // chapter slice for classes/subjects
  const { classes = [], subjects = [] } = useSelector(
    (state) => state.chapter || {},
  );

  // Local state
  const [groups, setGroups] = useState([]);
  const [error, setError] = useState("");

  // useEffect(() => {
  //   if (quizType === "thematic") {
  //     dispatch(getAgeGroups());
  //   }
  // }, [quizType]);
  // Destructure form fields (these keys are kept in redux form)
  const {
    question = "",
    option_a = "",
    option_b = "",
    option_c = "",
    option_d = "",
    correct_option = "",
    difficulty_level = "",
    class_id = "",
    subject_id = "",
    theme_id = "",
    group_id = "",
  } = newQuestionForm;

  // safe user id parsing
  const userStr = localStorage.getItem("user");
  const userObj = userStr ? JSON.parse(userStr) : {};
  const userId = userObj?.id ?? userObj?.user_id ?? "";

  // Fetch classes, themes and groups on mount
  useEffect(() => {
    dispatch(fetchClassesThunk());
    dispatch(fetchThemes());
    dispatch(fetchQuizTypes());
    fetchGroups();
    dispatch(fetchSubjects());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  useEffect(() => {
    setState({
      key: "quizType",
      value: "",
    });
  }, [dispatch]);
  // useEffect(() => {
  //   if (newQuestionForm?.subject_id) {
  //     const subject_id = newQuestionForm?.subject_id;
  //     dispatch(
  //       fetchSubjectBasedClassesData({
  //         subject_id,
  //       })
  //     );
  //   }
  // }, [dispatch, newQuestionForm?.subject_id]);

  useEffect(() => {
    const subject_id = newQuestionForm?.subject_id;

    // Clear old classes immediately when subject changes
    dispatch(
      setState({
        key: "subjectBasedClasses",
        value: { data: [] },
      }),
    );

    // Also clear previously selected class
    dispatch(
      setNewQuestionForm({
        key: "class_id",
        value: "",
      }),
    );

    if (subject_id) {
      dispatch(
        fetchSubjectBasedClassesData({
          subject_id: Number(subject_id),
        }),
      );
    }
  }, [dispatch, newQuestionForm?.subject_id]);
  // Fetch groups (same pattern used in other components)
  const fetchGroups = async () => {
    setError("");
    try {
      const res = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/groups`);
      setGroups(Array.isArray(res.data) ? res.data : res.data?.data || []);
    } catch (err) {
      setError("Failed to fetch groups");
      console.error("fetchGroups error:", err);
    }
  };

  // When a class is selected, fetch subjects for that class
  useEffect(() => {
    if (class_id) {
      // ensure numeric id if your thunk expects it
      dispatch(fetchSubjectsByClassThunk(Number(class_id)));
    }
  }, [class_id, dispatch]);

  // Generic form field update -> stores to redux newQuestionForm
  const handleChange = (key, value) => {
    dispatch(setNewQuestionForm({ key, value }));
  };

  const handleFieldChange = (e) => {
    //debugger
    const { name, value } = e.target;
    // correct payload shape expected by reducer:
    dispatch(setNewQuestionForm({ key: name, value }));
  };

  // Validation: require common fields + conditional fields based on quizType
  const isCommonValid =
    question.trim() &&
    option_a.trim() &&
    option_b.trim() &&
    option_c.trim() &&
    option_d.trim() &&
    correct_option.trim() &&
    difficulty_level;

  const isFormValid = [3, 4].includes(subQuizType)
    ? isCommonValid && theme_id && group_id
    : isCommonValid && class_id && subject_id;

  const handleThemeChange = (e) => {
    //debugger;
    const value = e.target.value;
    // update redux form properly
    dispatch(setNewQuestionForm({ key: "theme_id", value }));
    dispatch(
      setState({
        key: "selectedSubThemes",
        value: [],
      }),
    );
    const filtered =
      themes.find((e) => e.theme_id === Number(value))?.sub_theme || [];
    dispatch(
      setState({
        key: "subThemes",
        value: filtered,
      }),
    );
    // console.log("themens", themes);
    // handleChange("theme_id", value);
  };

  // Submit handler builds payload depending on quizType
  const handleSubmit = async () => {
    if (!isFormValid) {
      alert("Please fill required fields.");
      return;
    }

    try {
      const payloadBase = {
        created_by: userId || null,
        question,
        correct_option,
        option_A: option_a,
        option_B: option_b,
        option_C: option_c,
        option_D: option_d,
        level: difficulty_level,
      };

      // quizType === "thematic"
      const payload =
        subQuizType === 3 || subQuizType === 4
          ? {
              ...payloadBase,
              // theme_id: theme_id ? Number(theme_id) : undefined,
              theme_id: newQuestionForm.theme_id
                ? selectedSubThemes?.length
                  ? selectedSubThemes
                  : [newQuestionForm.theme_id]
                : [],
              group_id: group_id ? Number(group_id) : undefined,
              quiz_type: subQuizType,
              // age_group_id,
            }
          : {
              ...payloadBase,
              class_id: class_id ? Number(class_id) : undefined,
              subject_id: subject_id ? Number(subject_id) : undefined,
              quiz_type: subQuizType,
              //  === "practice" ? "practice" : "live",
            };

      // Optional: remove undefined keys
      Object.keys(payload).forEach(
        (k) => payload[k] == null && delete payload[k],
      );

      console.log(payload);

      // dispatch addManualQuestion (your thunk will get the payload)
      const res = await dispatch(addManualQuestion(payload)).unwrap();

      alert(
        res && typeof res === "object"
          ? res.message || "Question added successfully."
          : String(res) || "Question added successfully.",
      );

      // Reset form fields in Redux
      dispatch(
        setNewQuestionForm({
          key: "question",
          value: "",
        }),
      );
      dispatch(setNewQuestionForm({ key: "option_a", value: "" }));
      dispatch(setNewQuestionForm({ key: "option_b", value: "" }));
      dispatch(setNewQuestionForm({ key: "option_c", value: "" }));
      dispatch(setNewQuestionForm({ key: "option_d", value: "" }));
      dispatch(setNewQuestionForm({ key: "correct_option", value: "" }));
      dispatch(setNewQuestionForm({ key: "difficulty_level", value: "" }));
      dispatch(setNewQuestionForm({ key: "class_id", value: "" }));
      dispatch(setNewQuestionForm({ key: "subject_id", value: "" }));
      dispatch(setNewQuestionForm({ key: "theme_id", value: "" }));
      dispatch(setNewQuestionForm({ key: "group_id", value: "" }));
      window.location.reload();
    } catch (error) {
      console.error("Error adding manual question:", error);
      const errRes = error?.response?.data || error;
      alert(
        errRes && typeof errRes === "object"
          ? errRes.message || "Failed to add question."
          : String(errRes) || "Unknown error",
      );
    }
  };

  return (
    <div className="container-fluid w-100 mx-auto py-2 font-inter">
      <div className="row mx-auto w-100">
        <div className="col-md-12 w-100">
          <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
            Manual Entry – School Quiz Questions
          </h3>

          <div className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4">
            {/* Quiz Type select */}
            <div className="row mb-3">
              <label className="col-sm-4 col-form-label font-medium text-gray-700">
                Quiz Type
              </label>
              <div className="col-sm-8 d-flex align-items-center gap-3">
                {[
                  { label: "Live", value: 1 },
                  { label: "Practice", value: 0 },
                ].map((option) => (
                  <label
                    key={option.value}
                    className="form-check-label d-flex align-items-center gap-2"
                  >
                    <input
                      type="radio"
                      className="form-check-input"
                      name="quizType"
                      value={option.value}
                      checked={quizType === option.value} // loose equality to handle number/string
                      onChange={(e) => {
                        dispatch(
                          setState({
                            key: "quizType",
                            value: Number(e.target.value),
                          }),
                        );
                        dispatch(
                          setNewQuestionForm({ key: "theme_id", value: "" }),
                        );
                      }}
                      disabled={loading}
                    />
                    {option.label}
                  </label>
                ))}
              </div>
              {quizType !== "" && (
                <>
                  {[0, 1].includes(quizType) && (
                    <label className="col-sm-4 col-form-label font-medium text-gray-700">
                      Sub Quiz Type
                    </label>
                  )}
                  <div className="col-sm-8 d-flex align-items-center gap-3 flex-wrap">
                    {quizTypesList?.data
                      ?.filter((e) => e.is_live === quizType)
                      .map((quiz) => (
                        <label
                          key={quiz.id}
                          className="form-check-label d-flex align-items-center gap-2"
                        >
                          <input
                            type="radio"
                            className="form-check-input"
                            name="subQuizType"
                            value={quiz.id}
                            checked={subQuizType === quiz.id} // == handles string vs number
                            onChange={(e) => {
                              dispatch(
                                setState({
                                  key: "subQuizType",
                                  value: Number(e.target.value),
                                }),
                              );
                              dispatch(
                                setNewQuestionForm({
                                  key: "theme_id",
                                  value: "",
                                }),
                              );
                            }}
                            disabled={loading}
                          />
                          {quiz.type.charAt(0).toUpperCase() +
                            quiz.type.slice(1)}
                        </label>
                      ))}
                  </div>
                </>
              )}
            </div>
            {(subQuizType === 1 || subQuizType === 2) && (
              <div>
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label font-medium text-gray-700">
                    Subject
                  </label>
                  <div className="col-sm-8">
                    <select
                      className="form-select"
                      name="subject_id"
                      value={newQuestionForm?.subject_id || ""}
                      onChange={handleFieldChange}
                      // disabled={loading || !newQuestionForm?.class_id}
                    >
                      <option value="">-- Select --</option>
                      {(subjectsList?.data || []).map((s) => (
                        <option key={s.subject_id} value={s.subject_id}>
                          {s.subject_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label font-medium text-gray-700">
                    Class
                  </label>
                  <div className="col-sm-8">
                    <select
                      className="form-select"
                      name="class_id"
                      value={newQuestionForm?.class_id || ""}
                      onChange={(e) => {
                        handleFieldChange(e);
                      }}
                      disabled={loading || !newQuestionForm?.subject_id}
                    >
                      <option value="">-- Select --</option>
                      {(subjectBasedClasses?.data || []).map((s) => (
                        <option key={s.subject_id} value={s.class_id}>
                          {s.class_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}

            {(subQuizType === 3 || subQuizType === 4) && (
              <div>
                {/* Theme Dropdown */}
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label text-gray-700">
                    Theme
                  </label>

                  <div className="col-sm-8">
                    <select
                      className="form-select"
                      name="theme_id"
                      value={newQuestionForm?.theme_id || ""}
                      onChange={handleThemeChange}
                      disabled={loading}
                    >
                      <option value="">-- Select --</option>
                      {themes.map((theme) => (
                        <option key={theme.theme_id} value={theme.theme_id}>
                          {theme.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {newQuestionForm.theme_id && subThemes?.length > 0 && (
                  <div>
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label text-gray-700">
                        Sub Themes
                      </label>
                      <div className="col-sm-8">
                        <select
                          className="form-select"
                          value={selectedSubThemes?.[0] || ""}
                          onChange={(e) => {
                            dispatch(
                              setState({
                                key: "selectedSubThemes",
                                value: [Number(e.target.value)],
                              }),
                            );
                          }}
                          style={{ minWidth: "250px", padding: "6px" }}
                        >
                          <option value="">Select Sub Theme</option>
                          {subThemes.map((e) => (
                            <option key={e.theme_id} value={e.theme_id}>
                              {e.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
                {/* {newQuestionForm.theme_id &&
                  subThemes?.length > 0 &&
                  subThemes.map((e) => {
                    const selected = selectedSubThemes || []; // fallback in case it's undefined

                    return (
                      <label
                        key={e.theme_id}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginRight: "16px", // space between labels
                          // marginRight: "16px", // space between labels
                          marginBottom: "8px", // small vertical gap
                        }}
                      >
                        <input
                          type="checkbox"
                          style={{ marginRight: "20%" }}
                          value={e.theme_id}
                          checked={selected.includes(e.theme_id)}
                          onChange={(event) => {
                            const isChecked = event.target.checked;
                            let updatedList = [];

                            if (isChecked) {
                              updatedList = [...selected, e.theme_id];
                            } else {
                              updatedList = selected.filter(
                                (id) => id !== e.theme_id
                              );
                            }

                            dispatch(
                              setState({
                                key: "selectedSubThemes",
                                value: updatedList,
                              })
                            );
                          }}
                          className="mr-2"
                        />
                        <span className="text-gray-700">{e.name}</span>
                      </label>
                    );
                  })} */}
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label font-medium text-gray-700">
                    Groups
                  </label>
                  <div className="col-sm-8">
                    <div className="col-sm-8">
                      <select
                        className="form-select"
                        name="group_id"
                        value={newQuestionForm?.group_id || ""}
                        onChange={handleFieldChange}
                        disabled={loading}
                      >
                        <option value="">-- Select Group --</option>
                        {groups?.map((g) => (
                          <option key={g.group_id} value={g.group_id}>
                            {g.group_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Question input */}
            <div className="row mb-3">
              <label className="col-sm-4 col-form-label font-medium text-gray-700">
                Question
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  value={question}
                  onChange={(e) => handleChange("question", e.target.value)}
                />
              </div>
            </div>

            {/* Options & difficulty */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label text-gray-700 font-medium">
                  Option A
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={option_a}
                  onChange={(e) => handleChange("option_a", e.target.value)}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label text-gray-700 font-medium">
                  Option B
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={option_b}
                  onChange={(e) => handleChange("option_b", e.target.value)}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label text-gray-700 font-medium">
                  Option C
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={option_c}
                  onChange={(e) => handleChange("option_c", e.target.value)}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label text-gray-700 font-medium">
                  Option D
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={option_d}
                  onChange={(e) => handleChange("option_d", e.target.value)}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label text-gray-700 font-medium">
                  Correct Option
                </label>
                <select
                  className="form-select"
                  value={correct_option}
                  onChange={(e) =>
                    handleChange("correct_option", e.target.value)
                  }
                >
                  <option value="">-- Select ---</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                </select>
                {/* <input
                  type="text"
                  className="form-control"
                  value={correct_option}
                  onChange={(e) =>
                    handleChange("correct_option", e.target.value)
                  }
                /> */}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label text-gray-700 font-medium">
                  Difficulty Level
                </label>
                <select
                  className="form-select"
                  value={difficulty_level}
                  onChange={(e) =>
                    handleChange("difficulty_level", e.target.value)
                  }
                >
                  <option value="">-- Select Level --</option>
                  <option value="basic">Basic Level</option>
                  <option value="advanced">Advanced Level</option>
                  <option value="ultra">Ultra Level</option>
                  <option value="docmaster">Docmaster</option>
                </select>
              </div>
            </div>

            <div className="text-center mt-4">
              <button
                className="btn btn-primary px-4 py-2 rounded"
                disabled={!isFormValid}
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>

          <hr className="my-8 border-gray-300" />
        </div>
      </div>
    </div>
  );
}
